import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { PHONE_MOBILE, PHONE_RESIDENTIAL } from '../services/phone';
import PhoneInput from './phone-input';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';

export function entry(phone, typeId) {
  return { phone, typeId };
}

export function emptyEntry() {
  return entry('', '');
}

const styles = theme => ({
  phoneGroup: {
    display: 'flex',
    justifyContent: 'space-evenly'
  },
  phoneInput: {
    width: '100%'
  },
  categoriesInput: {
    marginLeft: '1rem',
    width: '100%'
  },
  helperText: {
    color: theme.palette.error.main,
    marginTop: 0
  }
});

const styled = withStyles(styles);

export class Phones extends Component {
  static defaultProps = {
    onBlur: Function.prototype,
    onChange: Function.prototype,
    onAddPhone: Function.prototype,
    onRemovePhone: Function.prototype,
    onChangePhone: Function.prototype,
    onChangeCategory: Function.prototype,
    phones: [entry('', PHONE_MOBILE), entry('', PHONE_RESIDENTIAL)],
    isActiveForm: true,
    required: 0
  }

  componentDidMount() {
    this.props.onChange(this.value());
  }

  phoneInput(ref, props) {
    return <TextField
      type="tel"
      label="Telefone"
      margin="dense"
      inputRef={ref}
      {...props}
    />;
  }

  value() { return [].concat(this.props.phones); }

  render() {
    const { categories = [], required, classes, error, helperText, phones } = this.props;

    return <>
      {phones.map(
        ({ phone, typeId }, i) => <div key={i} className={classes.phoneGroup}>
          <PhoneInput
            className={classes.phoneInput}
            render={this.phoneInput}
            onChange={ev => this.props.onChangePhone.call(undefined, ev, i)}
            onBlur={this.props.onBlur}
            InputLabelProps={{ shrink: !!phone }}
            value={phone}
            disabled={!this.props.isActiveForm}
            required={i < required}
          />

          <TextField
            onChange={ev => this.props.onChangeCategory.call(undefined, ev, i)}
            className={classes.categoriesInput}
            InputLabelProps={{ shrink: !!typeId }}
            value={typeId}
            onBlur={this.props.onBlur}
            margin="dense"
            label="Tipo"
            required={i < required}
            disabled={!this.props.isActiveForm}
            select
            SelectProps={{ native: true }}
          >
            <option key={-1} value=""></option>
            {
              categories.map(({ id, description }, j) => (
                <option key={j} value={id}>{description}</option>
              ))
            }
          </TextField>

          {
            phones.length > 1 ? (
              <IconButton
                onBlur={this.props.onBlur}
                onClick={ev => this.props.onRemovePhone(ev, i)}
                disabled={!this.props.isActiveForm}
              >
                <RemoveCircleIcon />
              </IconButton>
            ) : null
          }
        </div>
      )}

      { error ? <p className={classes.helperText}><small>{helperText}</small></p> : null }

      <Button color="primary" onClick={this.props.onAddPhone} disabled={!this.props.isActiveForm}>
        <AddIcon /> Adicionar Telefone
      </Button>
    </>;
  }
}

export default styled(Phones);
